import { SanityService } from "@modules/common/cms/sanityService"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { i18n } from "@modules/core/utils/i18n"
import { type CrossFitEventDto, CrossFitEventSchema, type EventDto } from "@modules/crossfitEvent/api/crossfitEventDto"
import { type CrossfitEventApiGateway } from "@modules/crossfitEvent/api/crossfitEventGateway"

export class CrossfitEventApi implements CrossfitEventApiGateway {
  private baseUrl = "/events"

  constructor(private api: ApiClient) {}

  async getEvents(): Promise<EventDto[]> {
    const result = await this.api.get<EventDto[]>(`${this.baseUrl}`)
    return result.data
  }

  async getCrossfitEvents(): Promise<CrossFitEventDto[]> {
    const result = await SanityService.client.fetch<CrossFitEventDto[]>(
      ` *[_type == "event" && language == 'en' && (dateTime(date.end + "T23:59:59Z") + 14*24*60*60 >= dateTime(now()))] | order(date.start asc) {
         ...,
         ...*[_type == "translation.metadata" && references(^._id)][0].translations[value->language == $language][0].value->{
            ...,
          },
       }`,
      {
        language: i18n.locale,
      },
    )
    return result.map((crossFitEventDto: CrossFitEventDto) =>
      LoggerService.parseApiDto(CrossFitEventSchema, crossFitEventDto),
    )
  }
}
